var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-8 mr-6 ml-6",staticStyle:{"color":"#526161"}},[_c('h1',[_vm._v("404 Not Found")]),_c('p',[_vm._v(" Please check the URL. Try going "),_c('span',{staticStyle:{"color":"#915233"},on:{"click":_vm.goHome}},[_vm._v("HERE")])]),_c('div',[_c('img',{staticClass:"space-img mt-16",attrs:{"src":`${_vm.publicPath}img/space.png`}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }